import React from 'react';
import { History } from 'history';
import { Grid } from '@mui/material';
import { Input, InputMoney, InputMultiline, InputNumber, Media, Text } from '../../components';
import BaseCreateEdit from '../base/base-create-edit.component';
import BaseView from '../base/base-view.component'; 
import Model from './eventquiz-model';  //editable..
import EventModel from '../event/event-model';
import QuizanswerPicklistCard from '../quizanswer/quizanswer-picklistcard.component';
import QuizanswerChecklistCard from '../quizanswer/quizanswer-checklistcard.component';
import AppService from '../../services/app.service';

interface IProps {
    history: History;
    eventId: number;
    datarowQuizquestion?: any;
    readOnly?: boolean;
    onSave?: (data: any) => void;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowEvent: any;
    quizAnswered: number;
    prevAnswer: string;
    save: boolean;
}

export default class EventquizCreatePublic extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowEvent: null,
            quizAnswered: 0,
            prevAnswer: '',
            save: false,
        }
        this.onChange = this.onChange.bind(this);
        this.onEndTyping = this.onEndTyping.bind(this);
    }

    private isMobile: boolean = AppService.isMobile();

    private eventDefault = (data: any) => {
        const separator = ' ➜ ';
        return {
            'name': data?.name + separator + this.props.datarowQuizquestion.name,
            'description': data?.name + separator + this.props.datarowQuizquestion.name,
            'event': data?.id, 
            'section': data?.section0?.id,
            'quizquestion': this.props.datarowQuizquestion.id,
            'questionType': this.props.datarowQuizquestion.type,
            }
    }

    private onLoad = (data: any) => {
        if (data) this.setState({datarow: {...data, ...this.eventDefault(this.state.datarowEvent), prevAnswer: data.answer}});            
    }

    private onLoadEvent = async(data: any) => {
        await this.setState({ datarow: {...this.state.datarow, ...this.eventDefault(data)}, datarowEvent: data });
    }

    private onLoadQuizanswer = async(data: any) => {
        data = ['yesno','optional'].includes(this.state.datarow.questionType)? [data] : data; 
        this.setState({ datarow: { ...this.state.datarow, 'quizanswer': data, 'quizanswerLength': data?.length || 0}, save: (this.state.datarow.name && this.state.datarow.event)});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onSave = async (data: any) => {
        const answered = this.state.datarow.quizanswerLength > 0? 1 : 0;
        data.answered = answered - this.state.datarow.answered;
        await this.props.onSave?.(data);
        await this.setState({datarow: {...this.state.datarow, id: data.id, answered: answered}, save: false});
    }    
    
    private onEndTyping() { 
        if (this.state.prevAnswer===this.state.datarow.answer) return;
        
        var data = null;
        if (this.props.datarowQuizquestion.quizanswerLength > 0)
            data = this.state.datarow.answer===this.props.datarowQuizquestion.quizanswerAnswer? this.props.datarowQuizquestion.quizanswer : null;
        
        this.onLoadQuizanswer(data)
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value
            }
        }
        this.setState(nextState);
    }
    render() {
        return (
            //editable..
            <BaseCreateEdit id={0} caption=' ' buttonCaption=' ' successCaption=' '
                model={Model} endPointFilter={Model.endPointFilter2(this.props.datarowQuizquestion.id, this.props.eventId)} datarow={this.state.datarow} save={this.state.save} onSave={this.onSave} onLoad={this.onLoad} onError={this.onError} disableAutoBack disableBackButton disableCard>
                
                <BaseView id={this.props.eventId} caption=' ' 
                    model={EventModel} onLoad={this.onLoadEvent}/>

                <Grid container justifyContent='center' width={this.isMobile? undefined : '60vw'} >
                    {!!this.props.datarowQuizquestion.title &&
                    <Text label={this.props.datarowQuizquestion.title} textAlign='center' color='primary.main' size='large' marginBottom={5} />
                    }
                
                    {this.props.datarowQuizquestion.seq === 1 &&
                    <Media url='https://www.youtube.com/embed/I3p-PuZB8no?si=faLSijn4joMjdJuK' sx={{border: 1, borderRadius: 2, mb: 5,}}/>
                    }

                    {!!this.props.datarowQuizquestion.imageUrl &&
                    <Media url={this.props.datarowQuizquestion.imageUrl} sx={{border: 1, borderRadius: 2, mb: 5}}/>
                    }
                </Grid>
                
                {this.props.datarowQuizquestion.quizanswerLength > 0 &&
                <>
                {this.props.datarowQuizquestion.type === 'yesno' &&
                <QuizanswerPicklistCard history={this.props.history} caption=' ' questionId={this.props.datarowQuizquestion.id} currentId={(this.props.datarowQuizquestion.quizanswerSamples || this.state.datarow.quizanswer)[0]?.id} onLoad={this.onLoadQuizanswer} cardCount={6} cardBorderRadius={20} cardAlign='center' swipe='horizontal' readOnly={this.props.readOnly} />
                }
                {this.props.datarowQuizquestion.type === 'optional' &&
                <QuizanswerPicklistCard history={this.props.history} caption=' ' questionId={this.props.datarowQuizquestion.id} currentId={(this.props.datarowQuizquestion.quizanswerSamples || this.state.datarow.quizanswer)[0]?.id} onLoad={this.onLoadQuizanswer} cardCount={6} cardBorderRadius={5} cardAlign='center' swipe='horizontal' readOnly={this.props.readOnly} />
                }
                {this.props.datarowQuizquestion.type === 'optionalthin' &&
                <QuizanswerPicklistCard history={this.props.history} caption=' ' questionId={this.props.datarowQuizquestion.id} currentId={(this.props.datarowQuizquestion.quizanswerSamples || this.state.datarow.quizanswer)[0]?.id} onLoad={this.onLoadQuizanswer} cardCount={this.isMobile? this.props.datarowQuizquestion.quizanswerLength : 16} cardBorderRadius={20} cardAlign='center' swipe='horizontal' readOnly={this.props.readOnly}/>
                }
                {this.props.datarowQuizquestion.type.includes('multiple') &&
                <QuizanswerChecklistCard history={this.props.history} caption=' ' questionId={this.props.datarowQuizquestion.id} currentId={this.props.datarowQuizquestion.quizanswerSamples || this.state.datarow.quizanswer} onLoad={this.onLoadQuizanswer} cardCount={6} cardAlign='center' readOnly={this.props.readOnly} />
                }
                </>
                }
                {this.props.datarowQuizquestion.quizanswerSamples?.seq > 0 &&
                <>
                {this.props.datarowQuizquestion.type=== 'freetext' &&
                <InputMultiline name='answer' value={this.state.datarow.answer} size='medium' box color={this.state.datarow.answer && 'primary.light'} error={this.state.errors?.answer} onChange={this.onChange} onEndTyping={this.onEndTyping} readOnly={this.props.readOnly} />
                } 
                {this.props.datarowQuizquestion.type === 'letter' &&
                <Input name='answer' value={this.state.datarow.answer.replace(/[^a-z\s]/gi,'')} size='medium' box color={this.state.datarow.answer && 'primary.light'} error={this.state.errors?.answer} onChange={this.onChange} onEndTyping={this.onEndTyping} readOnly={this.props.readOnly} />
                }   
                {this.props.datarowQuizquestion.type === 'letternumber' &&
                <Input name='answer' value={this.state.datarow.answer.replace(/[^a-z0-9\s]/gi,'')} size='medium' box color={this.state.datarow.answer && 'primary.light'} error={this.state.errors?.answer} onChange={this.onChange} onEndTyping={this.onEndTyping} readOnly={this.props.readOnly} />
                }  
                {this.props.datarowQuizquestion.type === 'number' &&
                <InputNumber name='answer' value={+this.state.datarow.answer} size='medium' autoSelect box color={this.state.datarow.answer && 'primary.light'} error={this.state.errors?.answer} onChange={this.onChange} onEndTyping={this.onEndTyping} readOnly={this.props.readOnly} />
                }
                {this.props.datarowQuizquestion.type === 'decimal' &&
                <InputNumber name='answer' value={+this.state.datarow.answer} size='medium' autoSelect box color={this.state.datarow.answer && 'primary.light'} error={this.state.errors?.answer} onChange={this.onChange} onEndTyping={this.onEndTyping} readOnly={this.props.readOnly} />
                }  
                {this.props.datarowQuizquestion.type === 'money' &&
                <InputMoney name='answer' value={+this.state.datarow.answer} size='medium' autoSelect box color={this.state.datarow.answer && 'primary.light'} error={this.state.errors?.answer} onChange={this.onChange} onEndTyping={this.onEndTyping} readOnly={this.props.readOnly} />
                }
                </>
                }
                <Grid container justifySelf='center' justifyContent='center' width='60%'>
                    <Text label={this.props.datarowQuizquestion.content} color='primary.light' textAlign='center' textToHtml />
                </Grid>
                {this.state.errors && 
                <Text label={'Terdapat kesalahan :' + Object.values(this.state.errors)?.[0]?.toString()} color='red' size='small' icon='error' marginTop={2}/>
                }
            </BaseCreateEdit>
        );
    }
}